import { AbstractControl, ValidationErrors } from '@angular/forms';

export function strongPasswordValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value;
  if (!value) return null;

  const hasMinLength = value.length >= 8;
  const hasUpperCase = /[A-Z]/.test(value);
  const hasDigit = /\d/.test(value);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);

  const valid = hasMinLength && hasUpperCase && hasDigit && hasSpecialChar;

  return valid
    ? null
    : {
        minLength: !hasMinLength,
        upperCase: !hasUpperCase,
        digit: !hasDigit,
        specialChar: !hasSpecialChar,
      };
}
